const ViewOrderDetail = (props) => {
    const {item} =props;
    
        return (
            <div className="order_detail_main">
            <div className="order_detail_wrapper">
                {/* <h4>Order Details</h4> */}
                <div className="d-sm-flex">
                    <div className="col-sm-5 col-12">
                        <span style={{ fontWeight: 'bold' }}>Ordered on </span>
                        <span>
                            {item?.orderDate
                                ? new Date(item?.orderDate).toLocaleDateString('en-GB', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                })
                                : null}
                        </span>
                    </div>
                    <div className="col-sm-5 col-12 mt-sm-0 mt-2">
                        <span style={{ fontWeight: 'bold' }}>OrderNo : </span>
                        <span>{item?.orderNo}</span>
                    </div>
                </div>
                <div className="order_all_detail_wrapper mt-3">
                    <div className="d-md-flex">
                        <div className="row col-md-8 col-12 justifu-content-between">
                            <div className="col-sm-5 col-12">
                                <h6>Shipping Address</h6>
                                <p>{item?.shippingAddress}</p>
                            </div>
                            <div className="col-sm-6 col-12">
                                <h6>Payment Methods</h6>
                                <p>BHIM UPI</p>
                            </div>
                        </div>
                        <div className="order_summary col-md-4 col-12 mt-md-0 mt-3">
                            <h6>Order Summary</h6>
                            <div className="order_summary_detail">
                                <span className="heading_order">Item(s) Subtotal:</span>
                                <span className="answ_order">₹{item?.orderAmount}</span>
                            </div>
                            <div className="order_summary_detail">
                                <span className="heading_order">Shipping</span>
                                <span className="answ_order">Free</span>
                            </div>
                            <div className="order_summary_detail">
                                <span className="heading_order">Grand Total:</span>
                                <span className="answ_order">₹{item?.totalAmount}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
    
    export default ViewOrderDetail;